import { Reveal, MaskText, Stagger, StaggerItem } from "./Reveal";

const AREAS = ["Market", "Product", "Customer", "Economics", "Operations", "Team", "Capital", "Founder"];

const CALLOUT = [
  "You've proven customers will buy.",
  "Your biggest challenge now isn't proving the idea — it's making demand more predictable and strengthening the systems underneath it.",
  "You may be tempted to jump into expansion. We'll explore that.",
  "But first, let's make sure the business underneath that growth is ready.",
];

export const Guide = () => (
  <section id="guide" className="relative bg-sand py-24 sm:py-32 overflow-hidden">
    <div className="mx-auto max-w-[1300px] px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-y-14 gap-x-12 items-center">
        <div className="lg:col-span-6">
          <span className="font-sans text-xs uppercase tracking-[0.28em] text-cognac">The Founder Roadmap Guide</span>
          <h2 className="mt-6 font-serif text-ocean tracking-[-0.02em] leading-[0.98] text-4xl sm:text-5xl lg:text-[3.9rem]">
            <MaskText lines={["A roadmap that", "actually knows", <span key="w" className="italic text-cognac">where you are.</span>]} />
          </h2>
          <div className="mt-8 max-w-xl font-sans text-base sm:text-lg text-ink/75 leading-relaxed space-y-5">
            <Reveal>
              <p>
                Two founders can face the exact same decision and need completely different advice.
                That's why this program doesn't force every entrepreneur through the same generic
                checklist.
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p>
                Your Founder Roadmap Guide asks questions about your business and uses Brian's
                lifecycle methodology to help identify what stage you're in — then adapts the
                roadmap experience accordingly.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="mt-9">
              <div className="font-sans text-[11px] uppercase tracking-[0.22em] text-ink/50">It considers</div>
              <Stagger className="mt-3 flex flex-wrap gap-2" amount={0.05}>
                {AREAS.map((a) => (
                  <StaggerItem key={a}>
                    <span className="font-serif text-lg text-ocean border border-[var(--line)] px-4 py-1.5">{a}</span>
                  </StaggerItem>
                ))}
              </Stagger>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-6 lg:pl-8">
          <Reveal delay={0.1}>
            <div data-testid="guide-callout" className="relative bg-cream border border-[var(--line)] p-8 sm:p-12 grain overflow-hidden">
              <div className="relative z-10">
                <div className="flex items-center gap-3 font-sans text-[11px] uppercase tracking-[0.22em] text-cognac">
                  <span className="h-1.5 w-1.5 bg-cognac" />
                  Founder Roadmap Guide · Day 1
                </div>
                <div className="mt-6 space-y-5 border-l-2 border-cognac/60 pl-6">
                  {CALLOUT.map((line, i) => (
                    <p key={i} className={`font-serif leading-snug ${i === 0 ? "text-2xl sm:text-3xl text-ocean" : "text-lg sm:text-xl text-ink/75"}`}>
                      {line}
                    </p>
                  ))}
                </div>
                <p className="mt-8 font-sans text-xs text-ink/45 leading-relaxed">
                  Supporting infrastructure, not the point. The value is Brian's methodology — made personal to your business.
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
